import { FaWrench, FaHammer, FaToolbox } from 'react-icons/fa';
import { images } from '../constants';

const pricing = [
  {
    id: 1,
    image: images.plan1,
    icon: <FaWrench />, // Wrench icon
    title: 'Basic Plan',
    price: 49,
    features: [
      'Basic Wood Repair',
      'Tool Rental',
      'Safety Gear Included',
      '24/7 Support',
      'Priority Service',
    ],
  },
  {
    id: 2,
    image: images.plan2,
    icon: <FaHammer />, // Hammer icon
    title: 'Standard Plan',
    price: 99,
    features: [
      'Advanced Wood Restoration',
      'Premium Tool Set',
      'Safety Gear Included',
      'Expert Consultation',
      'Priority Service',
    ],
  },
  {
    id: 3,
    image: images.plan3,
    icon: <FaToolbox />, // Toolbox icon
    title: 'Premium Plan',
    price: 149,
    features: [
      'Custom Woodwork Design',
      'Deluxe Tool Set',
      'Safety Gear Included',
      'On-Site Assistance',
      'Priority Service',
    ],
  },
];

export default pricing;